/* ============ Wishlist page ============ */
(function wl(){
  const $=s=>document.querySelector(s);
  if(!$('#wlGrid')||!window.OSO_STORE) return;
  if(window.osoAmbient) osoAmbient();
  const S=OSO_STORE, rup=n=>'₹'+n.toLocaleString('en-IN');
  const bag='<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';

  function render(){
    const items=S.wishlistItems();
    if(!items.length){$('#wlGrid').innerHTML='';$('#wlSub').style.display='none';$('#wlCount').textContent='';
      $('#wlEmpty').hidden=false; if(!$('#wlBear').innerHTML&&window.buildOsoLogo)$('#wlBear').innerHTML=buildOsoLogo('bear','#3a2a1e'); return;}
    $('#wlEmpty').hidden=true; $('#wlSub').style.display=''; $('#wlCount').textContent=items.length+(items.length===1?' piece':' pieces');
    $('#wlGrid').innerHTML=items.map(it=>{const p=OSO_findProduct(it.id), href=`/pages/product?id=${it.id}&c=${it.color.slice(1)}`;
      return `<div class="wl-card" data-key="${it.key}" data-id="${it.id}" data-c="${it.color}">
        <button class="wl-x" data-rm aria-label="Remove">&times;</button>
        <a class="wl-im" href="${href}">${shopTee(it.color,p.print)}</a>
        <div class="wl-b">
          <a class="wl-name" href="${href}">${p.name}</a>
          <div class="wl-cn">${it.cn} · ${rup(p.price)}</div>
          <div class="wl-sizes" role="group" aria-label="Size">${(()=>{const ck=OSO_colorKey(it.color),pick=OSO_defaultSize(p.id,ck);
            return OSO_sizesFor(p.id,ck).map(([z,n])=>
            `<button class="wl-z${z===pick?' on':''}${n?'':' oos'}"${n?'':' disabled'} data-z>${z}</button>`).join('');})()}</div>
          <button class="wl-add" data-add>${bag} Move to bag</button>
          <a class="wl-view" href="${href}">View product &rarr;</a>
        </div></div>`;}).join('');
    if(window.osoPeek) osoPeek('#wlGrid',{width:86});
  }

  $('#wlGrid').addEventListener('click',e=>{
    const card=e.target.closest('.wl-card'); if(!card) return;
    const {key,id,c}=card.dataset;
    const z=e.target.closest('[data-z]');
    if(z){card.querySelectorAll('.wl-z').forEach(x=>x.classList.toggle('on',x===z));return;}
    if(e.target.closest('[data-rm]')){gsap.to(card,{autoAlpha:0,scale:.92,duration:.28,ease:'power2.in',onComplete:()=>S.removeFromWishlist(key)});return;}
    if(e.target.closest('[data-add]')){
      const on=card.querySelector('.wl-z.on');
      S.addToCart(id,c,OSO_colorName(c),on?on.textContent.trim():'M',1);
      S.removeFromWishlist(key);
    }
  });

  window.addEventListener('oso:store',render);
  render();
  gsap.from('.wl-head, .wl-sub',{y:16,autoAlpha:0,duration:.6,stagger:.08,ease:'power2.out'});
  gsap.from('.wl-card',{y:22,autoAlpha:0,duration:.55,stagger:.08,ease:'power2.out',delay:.1});
})();
